import {useMemo} from "react";

import type {GetSemanticSearchStoreResponseDto} from "../types/GetSemanticSearchStoreResponseDto";

/**
 * Hook to get the offer_signup status from the conversation history
 * @param history - The semantic search conversation history
 * @returns The offer_signup status from the last API_RESPONSE message, or false if not found
 */
export function useOfferSignupStatus(history: GetSemanticSearchStoreResponseDto | undefined): boolean {
    return useMemo(() => {
        if (!history || history.length === 0) return false;

        // Find the last API_RESPONSE message
        for (let i = history.length - 1; i >= 0; i--) {
            if (history[i].type === "API_RESPONSE") {
                return history[i].offer_signup ?? false;
            }
        }

        return false;
    }, [history]);
}
import {useMemo} from "react";

import type {GetSemanticSearchStoreResponseDto} from "../types/GetSemanticSearchStoreResponseDto";

/**
 * Hook to get the offer_signup status from the conversation history
 * @param history - The semantic search conversation history
 * @returns The offer_signup status from the last API_RESPONSE message, or false if not found
 */
export function useOfferSignupStatus(history: GetSemanticSearchStoreResponseDto | undefined): boolean {
    return useMemo(() => {
        if (!history || history.length === 0) return false;

        // Find the last API_RESPONSE message
        for (let i = history.length - 1; i >= 0; i--) {
            if (history[i].type === "API_RESPONSE") {
                return history[i].offer_signup ?? false;
            }
        }

        return false;
    }, [history]);
}
